import React, { useContext, useState, useEffect } from "react";
import "../../styles/preparepdf.css";

import { ShareContext } from "../../context/ShareContext";

import { useNavigate, useLocation, Link } from "react-router-dom";
import * as Constants from "../../constants";

import BackLoader from "../../components/backloader";
import Seal from "../../assets/seal.png";
import Sign2 from "../../assets/sign.png";
import { Button } from "@mui/material";
import JisPrompt from "../../components/jisprompt";
import JisAlert from "../../components/jisalert";

import { green, red } from "@mui/material/colors";
import moment from "moment";
import DynamicIcon from "../dynamicicon";
import JisButton from "../controls/jisButton";
import JisDialog from "../dialog";
import JisDialogForm from "../formdialog";
import { CirclePlus, EditIcon, Trash2 } from "lucide-react";
import VirtualCallAudit from "./VirtualCallAudit";

function JisPrepareTemplate({
  templatedoc,
  docInfo,
  isLegal = true,
  doctype = "document",
  autoFill = [],
  onDone,
  isCfo,
  scheduleButtonText,
  onSchedule,
  onGoToNextIncomplete,
  isCompleteProofModal,
  isPaid,
  isCommissioned,
  isCurrentDocCommissioned,
}) {
  const {
    isThirdOpt,
    setWhichUpload,
    profile,
    token,
    frequentData,
    setIsExpired,
  } = useContext(ShareContext);

  /*   console.log('auto fill in template')
  console.log(autoFill); */
  var item = docInfo;

  const urlSaveInst = `${Constants.apiUrl}/filing/uploadtemplate`;
  const urlInstrument = `${Constants.apiUrl}/filing/instrument`;
  const [html, setHtml] = useState("");

  const [holders, setHolders] = useState([]);
  const [holdervalues, setHolderValues] = useState({});
  const [presentTag, setPresentTag] = useState(new Set());
  const [upload, setUpload] = useState({ open: false, title: "", id: 0 });

  const pattern = /\[.+?\]/g;

  const affidavit_search_prefix = "LSJ/HC/AFF";
  const [cfoWarn, setCfoWarn] = useState(false);
  const [isDialog, setIsDialog] = useState(false);
  const [doc, setDocument] = useState({ uplines: [], uplinesigns: [] });
  const [currectdoc, setCurrentDoc] = useState(templatedoc);
  const [uplineIndex, setUplineIndex] = useState(0);

  const [isLoading, setIsLoading] = useState(false);

  const [seal, setSeal] = useState("");
  const [passport, setPassport] = useState("");
  const [sign, setSign] = useState("");
  const [initial, setInitial] = useState("");
  const [stamp, setStamp] = useState("");
  const [fAutoFill, setfAutoFill] = useState(autoFill);
  const [permissionList, setDocPermissionList] = useState(new Set());

  //load documents first, then load one by one
  const [posId, setPosId] = useState(0); //this is the main guy that is doing the selection
  const [dstart, setDStart] = useState({ isDragging: false });
  const [imgs, setImgs] = useState([]);
  const [activeFile, setActiveFile] = useState({});
  const [isSaved, setIsSaved] = useState(true);
  const [allDocCompleted, setAllDocCompleted] = useState(false); //this is to receive the server answer to know when last part is finally treated
  const [activeSub, setActiveSub] = useState({ open: false });
  const [refresh, setRefresh] = useState(false);

  const needpermission =
    "Document saved successfully! Wait for the CFO to commission your document ";
  const noneedpermission =
    "Document saved successfully! Wait for the CFO to initial your document";
  const finalmsgcase = `You have worked on all document(s), the case will now move to Process Section Assessors' Queue `;

  const finalmsgaffidavit =
    "You have worked on the affidavit. The process is completed now";
  const finalmssheriff = `Document processed successfully! You have worked on Service Sheriff affidavit. `;
  const finalsettlement = `Term of settlement processed successfully! `;

  const prepareWritoffifa =
    "Document saved successfully! Wait for the ACR for Review ";
  const finalwritoffifa = `Case is going to Head of Process for further review`;
  const finalwarrant = `Case is going to Head of Process for Notice of Attachment`;

  const finalnotice ="The Hearing notice is Prepared. Will be waiting with selected Service sheriff to serve";
 
  const rework_note="Document rework is done, other document rework exist for this case either with Legal Counsel or CFO";
  const rework_final="Case moved to Screener or ACR to continue";

  // const permissionList =
  //   item.caseType == "adr"
  //     ? Constants.DocPermissionList_ADR
  //     : Constants.DocPermissionList;

  const onSaveInst = () => {
    if (!upload.isImage) return;

    onUploadIns();
  };

  const [imgPrev, setImgPrev] = useState({ data: "", type: "", open: false });

  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "" });
  const [prompt, setPrompt] = useState({
    open: false,
    title: "",
    subtitle: "",
    isImage: false,
  });

  const navigate = useNavigate();

  const onOk = () => {
    setAlert({ ...alert, open: false });
    // navigate("/affidavits");
  };
  const onOk_Save = () => {
    console.log("on going to onOk_Save");
    console.log(item);

    setAlert({ ...alert, open: false });

    if (item.type == "affidavit") {
      navigate("/affidavits");
    }
    if (
      item.type == "sheriff" ||
      doctype == "sheriff" ||
      doctype == "hearing-notice" ||
      item.type == "hearing-notice"
    ) {
      // For Service Sheriff, call onDone callback first to update status
      if (typeof onDone === "function") {
        onDone(currectdoc);
      }   else {
        // Fallback navigation if no callback
        navigate("/service-sheriff");
      }
      return; // Exit early to prevent duplicate onDone call
    }else if (doctype == "rework") {
        navigate(isLegal? "/rework/legalcounsel":'/rework/cfo');

    }

    if (typeof onDone === "function") {
      console.log("called onDone in the component");
      onDone(currectdoc);
    } else {
      console.log(typeof onDone);
    }
  };
  const onCancel = () => {};

  const confirmCaseDoc = () => {
    navigate("/upload/documents");
    setWhichUpload("Third");
  };

  useEffect(() => {
    console.log("autofill already changed");
    console.log(autoFill);
    if (!(autoFill == null || autoFill.length == 0)) {
      console.log("autlofill updated");
      setfAutoFill(autoFill);
    }
  }, [autoFill]);

  useEffect(() => {
    if(templatedoc==null) return;
    // onLoad();
      console.log(templatedoc)
    setCurrentDoc(templatedoc);
    onLoadPermissions();
    onLoadInstrument();
    //   var ftempid= currectdoc.upline.templateId;
var temp = templatedoc.template;
var htmlstr="";
    if( temp == null ) {
     htmlstr = Constants.b64decode(templatedoc.upline.templateHtml);
      setHtml(htmlstr);
    }else{
     htmlstr = Constants.b64decode(temp?.html);
    setHtml(htmlstr);
    }

    
    // var htmlstr=atob(temps[ftempid].html);
    
    //console.log('the html is set');
    if (templatedoc.upline.templateJson != null) {
      // console.log('json already exist');

      //convert to normal json then convert to object
      const jsonstr = atob(templatedoc.upline.templateJson);
      const jsobj = JSON.parse(jsonstr);
      //console.log(jsobj);

      setHolderValues(jsobj);
    } else {
      setHolderValues({});
    }
    const tags = Array.from(htmlstr.match(pattern));
    setPresentTag(new Set(tags));
    onTemplateHolder(temp?.id);
  }, [templatedoc]);

  const onLoadPermissions = async () => {
    //for account registration

    try {
      const resp = await fetch(
        `${Constants.apiUrl}/setup/gazette-lines-permission`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      if (data.code == 0) {
        console.log("list of permissions");
        console.log(data.ids);
        setDocPermissionList(new Set(data.ids));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onTemplateHolder = async (tempid) => {
    if(tempid==null) return;
    const temprl = `${Constants.apiUrl}/filing/templates/${tempid}/holders`;
    // console.log(`the calling url ${temprl}`);
    try {
      setIsLoading(true);
      const resp = await fetch(temprl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      // console.log(data);
      setIsLoading(false);
      if (data.code == 0) {
        setHolders(data.holders);
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const previewImage = async (event) => {
    //console.log("file read");
    const input = event.target;
    // setUpload upload
    //  console.log(input);
    if (input.files && input.files[0]) {
      var b64 = await Constants.toBase64(input.files[0]);
      setUpload({ ...upload, isImage: true, data: b64, file: input.files[0] });
    }
  };

  const onUploadIns = async () => {
    //     console.log('imgPrev data');
    //  console.log(upload);
    setIsLoading(true);
    //setImgPrev({...imgPrev,open:true,data:e.target.result,type:inst, title:"Upload "+inst, });
    var ext = upload.file.name?.split(".")[1];
    var rdata = {
      base64: upload.data?.split(",")[1],
      ext,
      holderId: upload.id,
    };
    // Sending the FormData using fetch
    fetch(urlSaveInst, {
      method: "POST",
      body: JSON.stringify(rdata),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          //saved already
          //get the real url and attach to the holdervalues of same id and check if value exist to display instead of displaying default
          // console.log(`the holder  ${upload.id}`)
          var hv = { ...holdervalues };
          var row = hv[upload.id];
          const filename = `${Constants.docUrl}holdermedia/${data.filename}`;
          if (row == null) {
            hv[upload.id] = {
              ...upload.holder,
              value: filename,
              type: "media",
            };
          } else {
            hv[upload.id] = { ...row, value: filename };
          }

          setHolderValues(hv);
          //   console.log(hv);
          setUpload({ open: false });
          replaceTemplate(hv);
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };

  const onAppendOnServer = async () => {
    setIsLoading(true);
    const url = `${Constants.apiUrl}/filing/appendInstrument/${currectdoc?.upline?.id}`;
    var ll = [];
    for (const x of imgs) {
      var l = { InstrumentType: x.instype, x: x.x, y: x.y };
      ll.push(l);
    }
    // Sending the FormData using fetch
    fetch(url, {
      method: "POST",
      body: JSON.stringify(ll),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          //saved already
          setImgPrev({ ...imgPrev, open: false });
          setAlert({
            ...alert,
            title: imgPrev.type,
            open: true,
            subtitle: `Saved Append Successfully`,
            onOk,
          });
          setPrompt({ ...prompt, open: false });
          onSetImg(data.instPath, imgPrev.type);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };

  const onSetImg = (path, type) => {
    const ct = type.toLowerCase();
    if (ct == "seal") {
      setSeal(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "passport") {
      setPassport(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "signature") {
      setSign(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "initial") {
      setInitial(`${Constants.docUrl}instrument/${path}`);
    } else if (ct == "stamp") {
      setStamp(`${Constants.docUrl}instrument/${path}`);
    }
  };

  const onLoadInstrument = async () => {
    //for account registration
    //  console.log(`the calling url ${urlInstrument}`);
    try {
      setIsLoading(true);
      const resp = await fetch(urlInstrument, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setIsLoading(false);
      if (data.code == 0) {
        //check if it contain any of the items
        //    console.log(data);
        for (const x of data.inst) {
          onSetImg(x.instPath, x.instrument);
        }
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onAddList = (holder) => {
    var hv = { ...holdervalues };
    var row = hv[holder.id];
    if (row.listobj == null) {
      row.listobj = [];
    }
    //row.listobj.push(row.value);
    //row.value=''; //empty the content
    //    console.log(row.value);
    hv[holder.id] = { ...row, listobj: [...row.listobj, row.value], value: "" };
    setHolderValues(hv);
    replaceTemplate(hv);
  };
  const onRemoveList = (holder, idx) => {
    var hv = { ...holdervalues };
    var row = hv[holder.id];

    var list = row.listobj;
    list.splice(idx, 1);
    //row.listobj.push(row.value);
    //row.value=''; //empty the content

    hv[holder.id] = { ...row, listobj: [...list], value: "" };
    setHolderValues(hv);
    replaceTemplate(hv);
  };
  const onEditList = (holder, idx) => {
    var hv = { ...holdervalues };
    var row = hv[holder.id];

    var list = row.listobj;

    hv[holder.id] = { ...row, value: list[idx].value, editindex: idx };
    //  console.log('something about index '+idx)
    //  console.log(hv[holder.id]);
    setHolderValues(hv);
    replaceTemplate(hv);
  };

  const onAddPara = (holder) => {
    var hv = { ...holdervalues };
    var row = hv[holder.id];
    if (row.editindex == null) {
      if (row.listobj == null) {
        row.listobj = [];
      }
      // row.listobj.push(row.value);
      //row.value=''; //empty the content
      //   console.log(row.value);
      const ovalue = { value: row.value, sub: [] };
      hv[holder.id] = { ...row, listobj: [...row.listobj, ovalue], value: "" };
      //  console.log(hv[holder.id].listobj);
    } else {
      //edit
      row.listobj[row.editindex] = {
        ...row.listobj[row.editindex],
        value: row.value,
      };
      hv[holder.id] = { ...row, value: "", editindex: null };
    }

    setHolderValues(hv);
    replaceTemplate(hv);
  };
  const onAddSubPara = () => {
    //relies on activeSub holder, ind, idx
    const idx = activeSub.idx;
    //console.log(`index of the item ${idx} value to add ${activeSub.value}`)
    var hv = { ...holdervalues };
    var row = hv[activeSub.holder.id];
    var list = row.listobj;
    var li = list[idx];
    //li.value, li.subs
    if (li.subs == null) {
      li.subs = [activeSub.value];
    } else {
      li.subs = [...li.subs, activeSub.value];
    }
    list[idx] = { ...li, subs: li.subs };
    row = { ...row, listobj: list };

    //row.value=''; //empty the content
    hv[activeSub.holder.id] = { ...row };
    setHolderValues(hv);
    setActiveSub({ open: false });
    replaceTemplate(hv);
  };
  const onRemoveSubList = (holder, idx, idxx) => {
    var hv = { ...holdervalues };
    var row = hv[holder.id];
    var list = row.listobj;
    var li = list[idx];

    li.subs.splice(idxx, 1);
    list[idx] = { ...li, subs: li.subs };
    row = { ...row, listobj: list };

    //row.value=''; //empty the content
    hv[holder.id] = { ...row };

    setHolderValues(hv);
    replaceTemplate(hv);
  };

  const onAppending = (holder) => {
    if (
      holder.dataType == "UPLOADED MEDIA[SIGNATURE-DEPONENT]" ||
      holder.dataType == "UPLOADED MEDIA[SIGNATURE-COMISSIONER]"
    ) {
      if (
        (permissionList.has(currectdoc?.upline?.gazetteItemId) ||
          item.type == "affidavit") &&
        !currectdoc?.upline?.allowSign
      ) {
        setAlert({
          icon: "warning",
          open: true,
          title: "Append ",
          subtitle:
            "Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled virtual call",
          onOk,
        });
        return;
      }
    }

    setUpload({
      open: true,
      title: holder.name,
      id: holder.id,
      holder,
      isImage: false,
    });
  };

  const returnTag = (holder, ind) => {
    var hv = { ...holdervalues };

    const m = fAutoFill?.find((d) => d.holder === holder.holder);
    if (m) {
      // const m= autoFill.filter((d)=>d.holder==holder.holder)[0]
      // console.log(`${m.value} holder: ${holder.holder}`);

      if (hv[holder.id] == null) {
        hv[holder.id] = { ...holder, value: m.value, type: "single" };
        setHolderValues(hv);
        replaceTemplate(hv);
      }
    } else if (holder.holder == "[DIVISION]" && item?.division != null) {
      //AUTO ADDED TO PROJECT. ITS AN IMAGE
      if (hv[holder.id] == null) {
        hv[holder.id] = { ...holder, value: item.division, type: "single" };
        setHolderValues(hv);
        replaceTemplate(hv);
      }
    } else if (holder.holder == "[SUIT_NO]" && item?.caseNumber != null) {
      //AUTO ADDED TO PROJECT. ITS AN IMAGE
      var row = hv[holder.id];
      if (hv[holder.id] == null) {
        hv[holder.id] = { ...holder, value: item.caseNumber, type: "single" };
        setHolderValues(hv);
        replaceTemplate(hv);
      }
    } else if (holder.dataType == "TEXT[NORMAL]") {
      return (
        <div className="input-create">
          <label htmlFor="doc-title">{holder.name} </label>
          <input
            type="text"
            placeholder={holder.hint}
            value={onGetValue(holder)}
            onChange={(e) => onDirectText(e, holder)}
          />
        </div>
      );
    } else if (holder.dataType == "TEXT[MULTIPLE-INPUT]") {
      const isAddToList = Constants.IsNull(holdervalues[holder.id]?.editindex);

      const onEditList = (holder, idx) => {
        var hv = { ...holdervalues };
        var row = hv[holder.id];

        hv[holder.id] = {
          ...row,
          value: row.listobj[idx],
          editindex: idx,
        };

        setHolderValues(hv);
      };

      const onAddUpdateList = (holder) => {
        if (isAddToList) onAddList(holder);
        else {
          var hv = { ...holdervalues };
          var row = hv[holder.id];

          // Update existing item
          row.listobj[row.editindex] = row.value;
          hv[holder.id] = { ...row, value: "", editindex: null };

          setHolderValues(hv);
          replaceTemplate(hv);
        }
      };

      return (
        <div className="input-create">
          <label htmlFor="defendant">{holder.name}</label>
          <div className="btn-input">
            <input
              type="text"
              placeholder={holder.hint}
              value={onGetValue(holder)}
              onChange={(e) => onDirectTextMultiple(e, holder, ind)}
            />
            <button onClick={() => onAddUpdateList(holder)}>
              <DynamicIcon iname="plus_circle" />
              {isAddToList ? "Add" : "Update"}
            </button>
          </div>
          <ul className="temp">
            {hv[holder.id] != null &&
              hv[holder.id].listobj?.map((li, idx) => {
                return (
                  <li key={idx}>
                    {" "}
                    <div className="content">{li}</div>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <button
                        style={{
                          padding: "14px",
                          borderRadius: "8px",
                          backgroundColor: "#5CA9FB",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          color: "#ffffff",
                        }}
                        className="icon"
                        onClick={() => onEditList(holder, idx)}
                      >
                        <DynamicIcon iname="edit" />
                        Edit
                      </button>
                      <button
                        style={{
                          padding: "14px",
                          borderRadius: "8px",
                          backgroundColor: "#ff0202ff",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          color: "#ffffff",
                        }}
                        className="icon"
                        onClick={() => onRemoveList(holder, idx)}
                      >
                        <DynamicIcon iname="trash" />
                        Del
                      </button>
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      );
    } else if (
      holder.dataType == "CFO-DATE" ||
      holder.dataType == "[CFO-DATE]" ||
      holder.dataType == "[COUNSEL-DATE]" ||
      holder.dataType == "COUNSEL-DATE" ||
      holder.dataType == "[DATE]"
    ) {
      return (
        <div className="input-create">
          <label htmlFor="doc-title">{holder.name}</label>
          <input
            type="date"
            placeholder={holder.hint}
            value={onGetValue(ind)}
            onChange={(e) => onDirectText(e, holder)}
          />
        </div>
      );
    } else if (
      holder.dataType == "[CFO-DATE-TIME-STAMP]" ||
      holder.dataType == "CFO-DATE-TIME-STAMP" ||
      holder.dataType == "[DATE-TIME-STAMP]"
    ) {
      return (
        <div className="append">
          <label htmlFor="doc-title" style={{ fontWeight: "bold" }}>
            {holder.name}{" "}
          </label>
          <button
            onClick={() => onTimeStamp(holder)}
            className="append_timestamp"
          >
            Append Timestamp
          </button>
        </div>
      );
    } else if (
      holder.dataType == "TEXT[LEGAL-COUNSEL-CONTACT]" ||
      holder.dataType == "TEXT[DETAIL-AND-SERVICE-ADDRESS-SECTION]"
    ) {
      return (
        <div className="input-create">
          <label htmlFor="doc-title">{holder.name} </label>
          <textarea
            id="paragraph"
            placeholder={holder.hint}
            value={onGetValue(holder)}
            onChange={(e) => onDirectText(e, holder)}
          ></textarea>
        </div>
      );
    } else if (holder.dataType == "TEXT[MULTIPLE-TEXTAREA]") {
      return (
        <div className="input-create">
          <label
            style={{
              textTransform: "capitalize",
            }}
            htmlFor="paragraph"
          >
            {holder.name}
          </label>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              position: "relative",
              backgroundColor: "#ffffff",
              marginBottom: "12px",
              marginTop: "8px",
            }}
          >
            <textarea
              style={{
                width: "100%",
                height: "64px",
                maxHeight: "64px",
                resize: "none",
                border: "1px solid #C8CACE",
                borderRadius: "8px",
                padding: "14px 35px 14px 14px",
              }}
              id="paragraph"
              placeholder={"holder.hint"}
              value={onGetValue(holder)}
              onChange={(e) => onDirectAreaMultiple(e, holder, ind)}
            ></textarea>
            <button
              className="add_btn_combo"
              onClick={() => onAddPara(holder)}
              type="button"
            >
              {Constants.IsNull(holdervalues[holder.id]?.editindex)
                ? "Add"
                : "Update"}

              {/* <DynamicIcon
                iname={
                  Constants.IsNull(holdervalues[holder.id]?.editindex)
                    ? "plus_circle"
                    : "edit"
                }
              /> */}
            </button>
          </div>
          <ul className="temp">
            {hv[holder.id] != null &&
              hv[holder.id].listobj?.map((li, idx) => {
                return (
                  <li
                    style={{
                      marginBlock: "10px",
                      display: "flex",
                      alignItems: "top",
                      justifyContent: "space-between",
                      position: "relative",
                      flexDirection: "column",
                      gap: "16px",
                    }}
                    key={idx}
                  >
                    <div className="content">
                      {li.value}
                      <div style={{ marginLeft: 16, marginRight: 16 }}>
                        {li.subs != null &&
                          li.subs?.map((sub, idxx) => {
                            return (
                              <div
                                key={idxx}
                                stlye={{ backgroundColor: "#ccc" }}
                              >
                                {" "}
                                <div className="content">
                                  {Constants.getAlphaByNum(idxx + 1)}). {sub}
                                </div>
                                <div className="action">
                                  <div
                                    className="icon"
                                    onClick={() =>
                                      onRemoveSubList(holder, idx, idxx)
                                    }
                                  >
                                    <DynamicIcon iname="close" />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          padding: "14px",
                          borderRadius: "8px",
                          backgroundColor: "#5CA9FB",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          color: "#ffffff",
                        }}
                        className="icon"
                        onClick={() => onEditList(holder, idx)}
                      >
                        <EditIcon />
                        Edit
                      </div>
                      <div
                        style={{
                          padding: "14px",
                          borderRadius: "8px",
                          backgroundColor: "#5CA9FB",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          color: "#ffffff",
                        }}
                        className="icon"
                        onClick={() =>
                          setActiveSub({
                            open: true,
                            holder,
                            idx,
                            title: "Sub Paragraph",
                          })
                        }
                      >
                        <CirclePlus />
                        Sub
                      </div>
                      <div
                        style={{
                          padding: "14px",
                          borderRadius: "8px",
                          backgroundColor: "#ff0202ff",
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          color: "#ffffff",
                        }}
                        className="icon"
                        onClick={() => onRemoveList(holder, idx)}
                      >
                        <Trash2 />
                        Del
                      </div>
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      );
    } else if (
      holder.dataType == "UPLOADED MEDIA[SIGNATURE-DEPONENT]" ||
      holder.dataType == "UPLOADED MEDIA[SEAL-COMISSIONER]" ||
      holder.dataType == "UPLOADED MEDIA[STAMP-COMISSIONER]" ||
      holder.dataType == "UPLOADED MEDIA[PASSPORT]" ||
      holder.dataType == "UPLOADED MEDIA[SEAL-DEPONENT]" ||
      holder.dataType == "UPLOADED MEDIA[SIGNATURE-COMISSIONER]" ||
      (holder.dataType == "UPLOADED MEDIA[IMAGE]" &&
        holder.holder != "[QR-CODE]" &&
        holder.holder != "[CASHIER_SEAL]" &&
        holder.holder != "[CASHIER_STAMP]")
    ) {
      const ss = checkMedia(holder);
      const label = isCompleteProofModal
        ? "SS"
        : profile.role.name === "Affidavit User"
          ? ""
          : profile.role.name === "Legal Counsel"
            ? "Deponent"
            : "CFO";

      return (
        <div className="append">
          <div className="instrument-img">
            <img
              src={
                holdervalues[holder.id] == null
                  ? ss.status
                    ? ss.imgPath
                    : Seal
                  : holdervalues[holder.id]?.value
              }
              alt="Instrument"
              style={{ width: 100 }}
            />

            <p>{`${label} ${ss.type}`}</p>
          </div>
          <div className="buttongrp">
            {ss.status && (
              <div>
                <button
                  //   className="black"
                  className={"apply_btn"}
                  onClick={() => onAppendStoreImg(holder, ss.imgPath)}
                >
                  Apply
                </button>
              </div>
            )}
            <div className="append-create" onClick={() => onAppending(holder)}>
              <label htmlFor="append-seal">
                {ss.status ? `Choose Another ${ss.type}` : holder.name}
              </label>
            </div>
          </div>
        </div>
      );
    } else if (holder.holder == "[QR-CODE]") {
      //AUTO ADDED TO PROJECT. ITS AN IMAGE
      var hv = { ...holdervalues };
      var row = hv[holder.id];
      if (hv[holder.id] == null) {
        //    console.log('found qrcode within document')
        // var searchlink=`DOC/JS/${item.caseFeeId}/${item.id}/${currectdoc?.id}`;
        // var searchlink =
        //   item.type == "affidavit"
        //     ? `${Constants.baseurl}/search/${affidavit_search_prefix}/${
        //         currectdoc?.upline?.id
        //       }/${retrieveDocYear()}}`
        //     : `${Constants.baseurl}/search/${item.caseNumber}/HC/${currectdoc?.upline?.id}}`;
        var searchlink = `${Constants.baseurl}/search/${currectdoc?.upline?.docRef}`;
        var urlimg = Constants.QrCodelink(searchlink);
        onAppendStoreImg(holder, urlimg); //Write qrcode straing
      }
    } else if (holder.holder == "[CASHIER_SEAL]" && isPaid) {
      //AUTO ADDED TO PROJECT. ITS AN IMAGE
      var hv = { ...holdervalues };
      var row = hv[holder.id];
      if (hv[holder.id] == null) {
        //  console.log('found qrcode within document')
        // var searchlink=`DOC/JS/${item.caseFeeId}/${item.id}/${currectdoc?.id}`;
        var cashierlink = `${Constants.rooturl}/resources/special/cashier_seal_${currectdoc?.upline?.id}.png`;
        var urlimg = cashierlink;
        onAppendStoreImg(holder, urlimg); //Write qrcode straing
      }
    } else if (holder.holder == "[CASHIER_STAMP]" && isPaid) {
      //AUTO ADDED TO PROJECT. ITS AN IMAGE
      var hv = { ...holdervalues };
      var row = hv[holder.id];
      if (hv[holder.id] == null) {
        //     console.log('found qrcode within document')
        // var searchlink=`DOC/JS/${item.caseFeeId}/${item.id}/${currectdoc?.id}`;
        var cashierlink = `${Constants.rooturl}/resources/special/cashier_stamp.png`;
        var urlimg = cashierlink;
        onAppendStoreImg(holder, urlimg); //Write qrcode straing
      }
    } else {
      // hv[ind]={value:'', type:'text'}
      // setHolderValues(hv);
      return (
        <div>
          <div className="input-create">
            <label htmlFor="doc-title">{holder.name} </label>
            <input
              type="text"
              value={onGetValue(ind)}
              onChange={(e) => onDirectText(e, holder, ind)}
              placeholder={holder.hint}
            />
          </div>
        </div>
      );
    }
  };

  const onAppendStoreImg = (holder, imgpath) => {
    if (
      holder.dataType == "UPLOADED MEDIA[SIGNATURE-DEPONENT]" ||
      holder.dataType == "UPLOADED MEDIA[SIGNATURE-COMISSIONER]"
    ) {
      if (
        (permissionList.has(currectdoc?.upline?.gazetteItemId) ||
          item.type == "affidavit") &&
        !currectdoc?.upline?.allowSign
      ) {
        setAlert({
          icon: "warning",
          open: true,
          title: "Append ",
          subtitle:
            "Wait for the CFO to authorize appending a signature on the document. This approval will be granted during the scheduled virtual call",
          onOk,
        });
        return;
      }
    }

    var hv = { ...holdervalues };
    var row = hv[holder.id];
    if (hv[holder.id] == null) {
      hv[holder.id] = { ...holder, value: imgpath, type: "media" };
    } else {
      hv[holder.id] = { ...row, value: imgpath };
    }

    setHolderValues(hv);
    replaceTemplate(hv);
  };
  const checkMedia = (hh) => {
    //return object {status: true, imgpath: ''}, or {status:false}
    //seal==''? Seal : seal
    var holdertype = hh.dataType;
    if (hh.holder == "[CFO_SEAL]" || hh.holder == "[DEPONENT-SEAL]") {
      return { status: seal != "", imgPath: seal, type: "Seal" }; //this will return true if seal contain value else it will return false
    } else if (hh.holder == "[CFO_INITIAL]") {
      return { status: initial != "", imgPath: initial, type: "Initial" };
    } else if (hh.holder == "[CFO_STAMP]") {
      return { status: stamp != "", imgPath: stamp, type: "Stamp" };
    } else if (
      hh.holder == "[SIGNATURE-DEPONENT]" ||
      hh.holder == "[LEGAL-COUNSEL-SIGNATURE]"
    ) {
      //sign==''? Sign:sign
      return { status: sign != "", imgPath: sign, type: "Signature" };
    } else if (hh.holder == "[PASSPORT]") {
      return { status: passport != "", imgPath: passport, type: "Passport" };
    } else {
      return { status: false };
    }
  };

  const onDirectText = (e, holder) => {
    //  console.log(`the holder  ${holder.id}`)
    var str = Constants.ConvertText(e.target.value);
    //var str= e.target.value?.toUpperCase();
    const value = str;
    var hv = { ...holdervalues };
    var row = hv[holder.id];
    if (hv[holder.id] == null) {
      hv[holder.id] = { ...holder, value: value, type: "single" };
    } else {
      hv[holder.id] = { ...row, value: value };
    }

    setHolderValues(hv);
    //  console.log(hv);

    replaceTemplate(hv);
    setIsSaved(false);
  };
  const onTimeStamp = (holder) => {
    // console.log(`the holder  ${holder.id}`)
    var hv = { ...holdervalues };
    var row = hv[holder.id];
    const currentdate = new Date();
    //console.log(currentdate);
    var tstamp = moment(currentdate).format("DD/MM/YYYY hh:mm a");
    if (hv[holder.id] == null) {
      //   console.log('first time here');

      hv[holder.id] = { ...holder, value: tstamp, type: "single" };
    } else {
      //  console.log(`old value ${hv[holder.id].value} and new value is ${tstamp}` )
      hv[holder.id] = { ...row, value: tstamp };
      //  console.log('another time here');
    }

    /*    var ftempid= currectdoc.selectedTemplate.split('|')[0];
             var htmlstr=atob(templates[ftempid].html)
             var rhtml=htmlstr ;//.replace(holder,e.target.value)
 */
    setHolderValues(hv);

    replaceTemplate(hv);
    setIsSaved(false);
  };

  const onDirectTextMultiple = (e, holder) => {
    var hv = { ...holdervalues };
    const value = Constants.ConvertText(e.target.value?.toUpperCase());
    var row = hv[holder.id];
    if (hv[holder.id] == null) {
      hv[holder.id] = { ...holder, value, type: "list" };
    } else {
      hv[holder.id] = { ...row, value };
    }

    setHolderValues(hv);
    setIsSaved(false);
    // console.log(hv);
  };

  const onDirectAreaMultiple = (e, holder) => {
    var hv = { ...holdervalues };
    var row = hv[holder.id];
    var value = Constants.ConvertText(e.target.value);
    if (hv[holder.id] == null) {
      hv[holder.id] = { ...holder, value, type: "paragraph" };
    } else {
      hv[holder.id] = { ...row, value };
    }

    setHolderValues(hv);
    //  console.log(hv);
    setIsSaved(false);
  };

  const onDirectDate = (e, holder, index) => {};
  const onGetValue = (holder) => {
    return holdervalues[holder.id]?.value;
  };

  const createMediaElement = (holder, value) => {
    const mediaConfig = {
      "[QR-CODE]": {
        wrapperStyle:
          "margin: 10px 0; display: flex; align-items: center; justify-content: center; float: right; margin: 0 0 10px 10px; clear: right;",
        imgStyle:
          "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
        size: "100px",
      },
      "[PASSPORT]": {
        wrapperStyle:
          "margin: 10px 0; display: flex; align-items: center; justify-content: center; float: left; margin: 0 10px 10px 0; clear: left;",
        imgStyle:
          "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
        size: "100px",
      },
      "[CFO_INITIAL]": {
        wrapperStyle:
          "display: inline-flex; align-items: center; vertical-align: middle; margin: 0 5px;",
        imgStyle:
          "display: inline-block; vertical-align: middle; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent; width: 80px;",
        size: "80px",
        inline: true,
      },
      "[CASHIER_SEAL]": {
        wrapperStyle:
          "margin: 10px 0; display: flex; align-items: center; justify-content: center; float: left; clear: none; margin: 10px 10px 10px 0; width: auto;",
        imgStyle:
          "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
        size: "100px",
      },
      "[CASHIER_STAMP]": {
        wrapperStyle:
          "margin: 10px 0; display: flex; align-items: center; justify-content: center; float: right; clear: none; margin: 10px 0 10px 10px; width: auto;",
        imgStyle:
          "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
        size: "100px",
      },
      "[CFO_SEAL]": {
        wrapperStyle:
          "margin: 10px 0; display: flex; align-items: center; justify-content: center; text-align: center;",
        imgStyle:
          "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
        size: "100px",
      },
      "[DEPONENT-SEAL]": {
        wrapperStyle:
          "margin: 10px 0; display: flex; align-items: center; justify-content: center; text-align: center;",
        imgStyle:
          "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
        size: "100px",
      },
      "[CFO_STAMP]": {
        wrapperStyle:
          "margin: 10px 0; display: flex; align-items: center; justify-content: center; text-align: center;",
        imgStyle:
          "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
        size: "100px",
      },
      "[SIGNATURE-DEPONENT]": {
        wrapperStyle:
          "margin: 10px 0; display: flex; align-items: center; justify-content: flex-end; text-align: right;",
        imgStyle:
          "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
        size: "100px",
      },
      "[LEGAL-COUNSEL-SIGNATURE]": {
        wrapperStyle:
          "margin: 10px 0; display: flex; align-items: center; justify-content: flex-start; text-align: left;",
        imgStyle:
          "display: block; max-width: 100%; height: auto; object-fit: contain; border: none; background: transparent;",
        size: "100px",
      },
    };

    const config = mediaConfig[holder] || {
      wrapperStyle:
        "margin: 10px 0; display: flex; align-items: center; justify-content: center;",
      imgStyle:
        "display: block; max-width: 100%; height: auto; object-fit: contain;",
      size: "100px",
    };

    if (config.inline) {
      return `<span style="${config.wrapperStyle}"><img src="${value}" style="${config.imgStyle}" width="${config.size}" alt="Media" /></span>`;
    }

    return `<div style="${config.wrapperStyle}"><img src="${value}" style="${config.imgStyle}" width="${config.size}" alt="Media" /></div>`;
  };

  const replaceTemplate = (obj) => {
    if (currectdoc.template == null) return;

    var htmlstr = Constants.b64decode(currectdoc.template.html);
    var rhtml = htmlstr;

    for (const ho of Object.values(obj)) {
      if (ho.type == "single") {
        const escapedValue = ho.value || "";
        rhtml = Constants.ReplaceAll(rhtml, ho.holder, escapedValue);
        rhtml = rhtml.replace(/(?:\r\n|\r|\n)/g, "<br>");
      } else if (ho.type == "media") {
        if (ho.holder === "[QR-CODE]" && !isCurrentDocCommissioned) {
          rhtml = Constants.ReplaceAll(rhtml, ho.holder, "");
          continue;
        }

        let mediaHtml = createMediaElement(ho.holder, ho.value);

        // Add clearfix after cashier stamp to force next content to new line
        if (ho.holder === "[CASHIER_STAMP]") {
          mediaHtml += '<div style="clear: both;"></div>';
        }

        rhtml = Constants.ReplaceAll(rhtml, ho.holder, mediaHtml);
      } else if (ho.type == "list") {
        if (ho.listobj != null && ho.listobj.length > 0) {
          let listHtml = '<div style="margin: 16px 0; padding: 0 16px;">';
          listHtml +=
            '<ol style="list-style-type: decimal; margin: 0; padding-left: 25px;">';

          for (const li of ho.listobj) {
            listHtml += `<li style="margin: 8px 0; padding-left: 5px; line-height: 1.6; color: #282828; font-size: 14px;">${li}</li>`;
          }

          listHtml += "</ol></div>";
          rhtml = Constants.ReplaceAll(rhtml, ho.holder, listHtml);
        }
      } else if (ho.type == "paragraph") {
        if (ho.listobj != null && ho.listobj.length > 0) {
          let paraHtml = '<div style="margin: 16px 0; padding: 0 16px;">';

          ho.listobj.forEach((li, idx) => {
            paraHtml += `<div style="margin: 12px 0;">`;
            paraHtml += `<div style="font-size: 14px; line-height: 1.6; color: #282828; margin-bottom: 8px; font-weight: 500;">${
              idx + 1
            }. ${li.value}</div>`;

            if (li.subs != null && li.subs.length > 0) {
              paraHtml +=
                '<div style="margin: 8px 0 8px 25px; padding-left: 10px; border-left: 2px solid #e5e7eb;">';

              li.subs.forEach((sub, subIdx) => {
                const alphaLabel = Constants.getAlphaByNum(subIdx + 1);
                paraHtml += `<div style="font-size: 14px; line-height: 1.6; color: #404040; margin: 6px 0; padding-left: 5px;">${alphaLabel}). ${sub}</div>`;
              });

              paraHtml += "</div>";
            }

            paraHtml += "</div>";
          });

          paraHtml += "</div>";
          rhtml = Constants.ReplaceAll(rhtml, ho.holder, paraHtml);
        }
      }
    }

    setHtml(rhtml);
  };

  const getHtmlForSave = (obj) => {
    if (currectdoc.template == null) return html;
    var htmlstr = Constants.b64decode(currectdoc.template.html);
    var rhtml = htmlstr;

    for (const ho of Object.values(obj)) {
      if (ho.type == "single") {
        const escapedValue = ho.value || "";
        rhtml = Constants.ReplaceAll(rhtml, ho.holder, escapedValue);
        rhtml = rhtml.replace(/(?:\r\n|\r|\n)/g, "<br>");
      } else if (ho.type == "media") {
        let mediaHtml = createMediaElement(ho.holder, ho.value);
        if (ho.holder === "[CASHIER_STAMP]") {
          mediaHtml += '<div style="clear: both;"></div>';
        }
        rhtml = Constants.ReplaceAll(rhtml, ho.holder, mediaHtml);
      } else if (ho.type == "list") {
        if (ho.listobj != null && ho.listobj.length > 0) {
          let listHtml = '<div style="margin: 16px 0; padding: 0 16px;">';
          listHtml +=
            '<ol style="list-style-type: decimal; margin: 0; padding-left: 25px;">';
          for (const li of ho.listobj) {
            listHtml += `<li style="margin: 8px 0; padding-left: 5px; line-height: 1.6; color: #282828; font-size: 14px;">${li}</li>`;
          }
          listHtml += "</ol></div>";
          rhtml = Constants.ReplaceAll(rhtml, ho.holder, listHtml);
        }
      } else if (ho.type == "paragraph") {
        if (ho.listobj != null && ho.listobj.length > 0) {
          let paraHtml = '<div style="margin: 16px 0; padding: 0 16px;">';
          ho.listobj.forEach((li, idx) => {
            paraHtml += `<div style="margin: 12px 0;">`;
            paraHtml += `<div style="font-size: 14px; line-height: 1.6; color: #282828; margin-bottom: 8px; font-weight: 500;">${
              idx + 1
            }. ${li.value}</div>`;
            if (li.subs != null && li.subs.length > 0) {
              paraHtml +=
                '<div style="margin: 8px 0 8px 25px; padding-left: 10px; border-left: 2px solid #e5e7eb;">';
              li.subs.forEach((sub, subIdx) => {
                const alphaLabel = Constants.getAlphaByNum(subIdx + 1);
                paraHtml += `<div style="font-size: 14px; line-height: 1.6; color: #404040; margin: 6px 0; padding-left: 5px;">${alphaLabel}). ${sub}</div>`;
              });
              paraHtml += "</div>";
            }
            paraHtml += "</div>";
          });
          paraHtml += "</div>";
          rhtml = Constants.ReplaceAll(rhtml, ho.holder, paraHtml);
        }
      }
    }

    return rhtml;
  };

  const goToNext = () => {
    onOk();
    if (typeof onGoToNextIncomplete === "function") {
      onGoToNextIncomplete();
    }
  };

  const onFinalProcess = async () => {
    //write the txt to pdf
    setIsDialog(false);
    try {
      const theurl = `${Constants.apiUrl}/filing/saveTemplateData/${currectdoc.upline.id}`;
      setIsLoading(true);
      var strjson = btoa(JSON.stringify(holdervalues));
      var base64 = Constants.b64encode(getHtmlForSave(holdervalues));
      const data = {
        docuplineId: currectdoc.upline.id,
        htmlstr: base64,
        jsonstr: strjson,
        doctype,
        Userid: profile.username,
        isFinal: true,
      };
      const resp = await fetch(theurl, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const responseData = await resp.json();
      setIsLoading(false);
      //      console.log('here1');
      //       console.log(responseData);
      if (responseData.code == 0) {
        // alert('saved to a pdf file');

        // setAlert(  {open:true,title:'Template', subtitle:'saved to a pdf file', onOk});

        if (responseData.incompleted == 0 || doctype=='rework') {
          setAlert({
            ...alert,
            title: "Process Document",
            open: true,
            subtitle: getFinalSubtitle(responseData.isVerified,responseData.incompleted),
            onOk: onIsCompleted,
          });
        } else {
          setAlert({
            ...alert,
            title: "Process Document",
            open: true,
            subtitle: `Processed Successfully. Document remain to be processed ${responseData.incompleted}`,
            onOk: goToNext,
          });
        }

        setIsSaved(true);
        // setAllDocCompleted(responseData.isFinal);
      } else if (responseData.code == -10) {
        setIsExpired(true);
      } else {
        setAlert({
          open: true,
          title: "Template",
          subtitle: responseData.status,
          onOk,
        });
      }
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const getFinalSubtitle = (isDocVerified,incomplete) => {
    if (isDocVerified) {
      const caseCategory = Constants.getItemById(
        frequentData?.casecategories,
        docInfo.caseCategoryId,
      )?.categoryTitle?.toLowerCase();
      console.log("caseCategory", caseCategory);
      if (caseCategory === "general civil" || caseCategory === "commercial") {
        return "You have worked on all document(s), the case will now move to Screener Queue.";
      }
      return "You have worked on all document(s), the case will now move to ACR Queue.";
    }
    return onfinalMsg(incomplete);
  };

  const onfinalMsg = (incomplete) => {
    if (item.type == "affidavit") {
      return finalmsgaffidavit;
    } else if (doctype == "sheriff") {
      return finalmssheriff;
    } else if (doctype == "settlement") {
      return finalsettlement;
    } else if (doctype == "service-sheriff-sub")
      return "You have worked on all doument(s). The case will now move to Case manger Queue";
    else if (doctype == "writ-of-fifa") {
      return finalwritoffifa;
    } else if (doctype == "writ-warrant") {
      return finalwarrant;
    } else if (doctype == "hearing-notice") {
      return finalnotice;
    } else if (doctype == "rework") {
      return incomplete==0? rework_final: rework_note;
    }  else {
      return finalmsgcase;
    }
  };

  // console.log({
  //   caseType: Constants.getItemById(frequentData?.casetype, docInfo.caseTypeId)
  //     ?.caseType1,
  //   caseCategory: Constants.getItemById(
  //     frequentData?.casecategories,
  //     docInfo.caseCategoryId,
  //   )?.categoryTitle,
  //   caseCategoryId: docInfo.caseCategoryId,
  //   caseCategories: frequentData?.casecategories,
  //   casesTypes: frequentData?.casetype,
  //   isDocVerified,
  //   finalmessage: getFinalSubtitle(),
  // });

  const onSaveMsg = (incomplete) => {
    if (
      permissionList.has(currectdoc?.upline?.gazetteItemId) ||
      item.type == "affidavit"
    ) {
      return needpermission;
    } else if (doctype == "sheriff") {
      return finalmssheriff;
    } else if (doctype == "settlement") {
      return finalsettlement;
    } else if (doctype == "service-sheriff-sub")
      return "Document saved successfully! ";
    else if (doctype == "writ-of-fifa") {
      return prepareWritoffifa;
    } else if (doctype == "hearing-notice") {
      return finalnotice;
    }else if (doctype == "rework") {
      return incomplete==0?rework_final: rework_note;
    } else {
      /* else if(doctype=='service-sheriff-sub')
          return "Document saved successfully! ";  */
      return needpermission;
    }
  };

  const onSaveDraft = async () => {
    //write the txt to pdf
    setIsDialog(false);
    //this will save only item added

    try {
      const theurl = `${Constants.apiUrl}/filing/saveTemplateData/${currectdoc.upline.id}`;
      setIsLoading(true);
      var stfy = JSON.stringify(holdervalues);
      var strjson = Constants.b64encode(stfy);
      //   console.log('json values of selected values ');
      // console.log(stfy);
      //var strhtml=btoa();

      //    console.log('possible html to btoa');
      // console.log(html);
      var base64 = Constants.b64encode(html);
      const data = {
        docuplineId: currectdoc.upline.id,
        jsonstr: strjson,
        htmlstr: base64,
        doctype,
        Userid: profile.username,
        isFinal: false,
      };
      const resp = await fetch(theurl, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const responseData = await resp.json();
      setIsLoading(false);
      if (responseData.code == 0) {
        // alert('saved to a pdf file');
        setAlert({
          open: true,
          title: "Document",
          subtitle: onSaveMsg(responseData.incompleted),
          onOk: onOk_Save,
        });
        setIsSaved(true);
      } else if (responseData.code == -10) {
        setIsExpired(true);
      } else {
        setAlert({
          open: true,
          title: "Document1",
          subtitle: responseData.status,
          onOk,
        });
      }

      setIsSaved(true);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const onProcessAction = () => {
    //check if all item is entered for on the
    // holdervalues
    const arrMain = Object.values(holdervalues);
    //compare if holders.length is same figure arrMains
    //arrMain.length== holders.length
    if (isLegal) {
      //completed but still check
      onSaveDraft();
    } else {
      onFinalProcess();
    }
  };

  const cancelUpload = () => {
    setUpload({ open: false });
  };

  const onIsCompleted = () => {
    // go to home page, when work is completed
    console.log(item.type, doctype, "is completed");
    setAlert({ ...alert, open: false });
    // window.location.replace(`${Constants.primarySite}/Users.aspx`)
    if (
      item.type === "affidavit" &&
      profile.role.name.toLowerCase() === "cfo"
    ) {
      navigate("/cfo-affidavits");
    } else if (item.type == "affidavit") {
      navigate("/affidavits");
    } else if (doctype == "sheriff") {
      navigate("/cfo-e-swearing-sheriff");
    } else if (doctype == "service-sheriff-sub") {
      navigate("/cfo-e-swearing-sheriff-substituted");
    } else if (doctype == "writ-of-fifa") {
      navigate("/acr-writ-of-fifa");
    } else if (doctype == "writ-warrant") {
      navigate("/judge-warrants");
    }else if (doctype == "rework") {
      navigate(isLegal? "/rework/legalcounsel":'/rework/cfo');
    } else {
      navigate("/cfo-e-swearing");
    }
  };

  useEffect(() => {
    replaceTemplate(holdervalues);
    /*  if(refresh){
        setTimeout(function () {
            //setBttnText("COPY CODE");
           
          }, 1000);
       setRefresh(false);
    } */
  }, [html, refresh, holdervalues]);

  const onAllowSign = (e) => {
    //   console.log(e.target.value);
    //setCurrentDoc({...currectdoc,upline.allowSign})
    onAllow(true, "sign");
  };
  const onAllowSeal = (e) => {
    // console.log(e.target.value);
    onAllow(true, "seal");
  };

  const onAllow = (isAllow, instType) => {
    const url = `${Constants.apiUrl}/filing/allowinstrument/${currectdoc?.upline?.id}`;
    var ll = {
      uplineId: currectdoc?.upline?.id,
      isAllow,
      instType,
      cfoUserid: profile.username,
    };
    setIsLoading(true);

    fetch(url, {
      method: "POST",
      body: JSON.stringify(ll),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.code == 0) {
          //saved already
          if (instType == "seal") {
            setCurrentDoc({
              ...currectdoc,
              upline: { ...currectdoc.upline, allowSeal: isAllow },
            });
          } else if (instType == "sign") {
            setCurrentDoc({
              ...currectdoc,
              upline: { ...currectdoc.upline, allowSign: isAllow },
            });
          }
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };

  const retrieveDocYear = () => {
    return currectdoc?.upline.uploadDate == null
      ? moment(new Date()).format("YYYY")
      : moment(currectdoc?.upline.uploadDate).format("YYYY");
  };

  return (
    <div style={{ width: "100%" }}>
      <div className="body" style={{ width: "100%" }}>
        <div className="document">
          <div className="doc-side">
            <div
              className="wrapper"
              style={{
                maxWidth: "100%",
                width: "100%",
                backgroundColor: "white",
                color: "black",
                padding: "16px",
                position: "relative",
                overflow: "auto",
              }}
            >
              <div
                className="htmlwrap"
                style={{
                  width: "100%",
                  maxWidth: "750px",
                  margin: "0 auto",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                }}
                dangerouslySetInnerHTML={{ __html: html }}
              ></div>
            </div>
          </div>

          {doctype!='rework' && isCommissioned && (
            <div className="action_wrapper no-print">
              <JisButton
                variant="primary"
                type="button"
                onClick={() => {
                  const printWindow = window.open("", "_blank");
                  printWindow.document.write(`<!DOCTYPE html>
<html>
<head>
  <title>Print Document</title>
  <style>
    body { margin: 1.6cm; padding: 0; font-family: serif; color: black; background: white; }
    * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    img { max-width: 100%; }
  </style>
</head>
<body>${html}</body>
</html>`);
                  printWindow.document.close();
                  printWindow.focus();
                  printWindow.onload = () => {
                    printWindow.print();
                    printWindow.close();
                  };
                }}
              >
                Print Document
              </JisButton>
            </div>
          )}
          {(doctype=='rework' || !isCommissioned) && (
            <div className="action_wrapper">
              {!isLegal && (
                <div className="cfo-create-submit-btn cfo-create-submit-action-btn">
                  <JisButton
                    variant="primary"
                    type="button"
                    onClick={onSchedule}
                  >
                    {scheduleButtonText}
                  </JisButton>
                  <JisButton variant="outline" type="button">
                    Rework Document
                  </JisButton>
                </div>
              )}
              {isCfo && (
                <VirtualCallAudit
                  docId={currectdoc?.upline?.id}
                  caseId={docInfo?.caseId}
                />
              )}
              <div className="actions">
                <div className="create-case cfo-create-case">
                  <div className="body">
                    <div className="top-nav">
                      <div
                        className={
                          "left-top " +
                          (isCfo ? "cfo-prepare-affidavit-section" : "")
                        }
                      >
                        {isCfo ? (
                          <div>
                            <p className="title">Affidavit Actions</p>
                            <p className="description">
                              Digitally signed and authorized seals, signatures,
                              and time stamps
                            </p>
                          </div>
                        ) : (
                          <p>
                            Please fill in the inputs and append seal and
                            signature{" "}
                          </p>
                        )}

                        {!isLegal &&
                          (permissionList.has(
                            currectdoc?.upline?.gazetteItemId,
                          ) ||
                            item.type == "affidavit") && (
                            <div className="check-sign">
                              <div className="cfo_input">
                                <input
                                  type="checkbox"
                                  id="check-cfo"
                                  checked={currectdoc?.upline?.allowSign}
                                  disabled={currectdoc?.upline?.allowSign}
                                  onChange={(e) => onAllowSign(e)}
                                />
                                <label htmlFor="check-cfo">
                                  Allow to Append Signature
                                </label>
                              </div>
                              {/* <div className="cfo_input">
                              <input
                                type="checkbox"
                                checked={currectdoc?.upline?.allowSeal}
                                id="check-cfo"
                                disabled={currectdoc?.upline?.allowSeal}
                                onChange={(e) => onAllowSeal(e)}
                              />
                              <label htmlFor="check-cfo">
                                Allow to Append Seal
                              </label>
                            </div> */}
                            </div>
                          )}

                        {(permissionList.has(
                          currectdoc?.upline?.gazetteItemId,
                        ) ||
                          item.type == "affidavit") && (
                          <div>
                            {currectdoc?.upline?.allowSign ? (
                              <span
                                style={{
                                  color: green[500],
                                  fontWeight: "bold",
                                }}
                              >
                                permission granted for you to append your
                                signature/seal{" "}
                              </span>
                            ) : (
                              <span
                                style={{ color: red[500], fontWeight: "bold" }}
                              >
                                Permission required for item{" "}
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                      <p className="nav-status"></p>
                    </div>

                    <div className="form cfo-prepare-affidavit-form ">
                      <div className="left-side">
                        {holders.length > 0 &&
                          holders?.map((ho, idx) => {
                            return (
                              ((isLegal &&
                                !Constants.CFO_Placeholders.has(ho.id)) ||
                                (!isLegal &&
                                  ho.dataType &&
                                  Constants.CFO_Placeholders.has(ho.id))) &&
                              ho.dataType !== "TEXT[MULTIPLE-TEXTAREA]" &&
                              returnTag(ho, idx)
                            );
                          })}
                      </div>
                    </div>

                    {/* Add Paragraph Section */}
                    <div className="paragraph-section">
                      {holders.length > 0 &&
                        holders
                          ?.filter(
                            (ho) => ho.dataType === "TEXT[MULTIPLE-TEXTAREA]",
                          )
                          ?.map((ho, idx) => {
                            return (
                              ((isLegal &&
                                !Constants.CFO_Placeholders.has(ho.id)) ||
                                (!isLegal &&
                                  ho.dataType &&
                                  Constants.CFO_Placeholders.has(ho.id))) &&
                              returnTag(ho, idx)
                            );
                          })}
                    </div>

                    <div className="down">
                      <div className="cfo-create-submit-btn">
                        <JisButton onClick={() => setIsDialog(true)}>
                          {isLegal ? "Save Document" : "Process Document"}
                        </JisButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="down">
          {!currectdoc.upline.isTemplate && (
            <Link to={`/upload/documents/${item.caseFeeId}`}>
              <span>Select Template</span>{" "}
            </Link>
          )}

          {isThirdOpt && (
            <button onClick={() => confirmCaseDoc()}>Confirm Document</button>
          )}
        </div>
      </div>
      {cfoWarn && (
        <div className={"warning show"}>
          <div className="container">
            <div className="icon" onClick={() => setCfoWarn(false)}>
              <DynamicIcon iname="close" />
            </div>
            <div className="body">
              <h3>Appending Signature</h3>
              <p>
                You are not allowed to upload your signature yet. Please wait
                for the Chief for Oath (CFO) authorizes you to upload your
                signature. In the mean time, you can upload your seal and
                passport{" "}
              </p>
              <button onClick={() => setCfoWarn(false)}>Ok</button>
            </div>
          </div>
        </div>
      )}

      <BackLoader open={isLoading} />
      {alert.open && <JisAlert {...alert} />}
      <JisPrompt
        open={isDialog}
        onOk={onProcessAction}
        onCancel={() => setIsDialog(false)}
      >
        <p
          style={{
            flexDirection: "row",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          {profile.role == "LegalCounsel" || profile.role == "Customer" ? (
            <strong>
              Are you sure you want to save this template ? You will not be able
              to amend after the Commissioner for Oaths has worked on it
            </strong>
          ) : (
            <strong>Are you sure you want to process this template ?</strong>
          )}
        </p>
      </JisPrompt>

      {upload.open && (
        <JisDialogForm title="Upload" minWidth="40%" onClose={cancelUpload}>
          <div>
            <div className="upload-wrap">
              <h3>{upload.title}</h3>
              <div className="upload-file-btn">
                <label htmlFor="upload-input" className="upload-input-label">
                  <input
                    type="file"
                    id="upload-input"
                    accept="image/*"
                    onChange={previewImage}
                    placeholder="uploading image"
                  />
                  upload image
                </label>
                {upload.isImage && (
                  <img
                    src={upload.data}
                    style={{ height: 100 }}
                    alt="Uploaded Media"
                  />
                )}
              </div>

              <p className="warn">Maximum File Upload: 1mb</p>
              <div className="schedule_btn_wrapper">
                <button variant="default" onClick={() => cancelUpload()}>
                  Cancel
                </button>
                <button icon="check_circle" onClick={onSaveInst}>
                  Upload
                </button>
              </div>
            </div>
          </div>
        </JisDialogForm>
      )}

      {activeSub.open && (
        <JisDialog title={activeSub.title}>
          <div className="upload-wrap">
            <textarea
              value={activeSub.value}
              style={{ width: "100%", height: 100, padding: 16 }}
              onChange={(e) =>
                setActiveSub({
                  ...activeSub,
                  value: Constants.ConvertText(e.target.value),
                })
              }
            ></textarea>

            <button icon="check_circle" onClick={onAddSubPara}>
              Add Sub Paragraph
            </button>
            <button
              className="red"
              onClick={() => setActiveSub({ open: false })}
            >
              Cancel
            </button>
          </div>
        </JisDialog>
      )}
    </div>
  );
}

export default JisPrepareTemplate;
